import { AppBar, Button, IconButton, Link, Menu, MenuItem, Toolbar, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from "react";
import AuthGen2 from "./authGen2";

const Header: React.FC  = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = () => {
    setMenuOpen(false);
    setAnchorEl(null);
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if(!menuOpen){
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    }
  } 

    return (
      <AppBar position="static" elevation={2}>
        <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 0.5, sm: 1, md: 1.5 } }}>
          {/* Left side - Menu and Title */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: { xs: 0.5, sm: 0.5, md: 1 } }}
              onClick={handleClick}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <MenuItem onClick={handleClose}>
                <Link
                  href="/howtoplay"
                  underline="none"
                  color="inherit"
                  sx={{ width: '100%', display: 'block' }}
                >
                  How to Play
                </Link>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <Link
                  href="/leaderboard"
                  underline="none"
                  color="inherit"
                  sx={{ width: '100%', display: 'block' }}
                >
                  Leaderboard
                </Link>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <Link
                  href="/friends"
                  underline="none"
                  color="inherit"
                  sx={{ width: '100%', display: 'block' }}
                >
                  Friends
                </Link>
              </MenuItem>
            </Menu>
            
            <Button
              color="inherit"
              href="/"
              sx={{
                textTransform: "none",
                px: { xs: 0.5, sm: 1 },
                py: { xs: 0.5, sm: 1 },
                minWidth: 'auto',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              <Typography
                variant="h5"
                component="h1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem', lg: '1.5rem' },
                  whiteSpace: 'nowrap'
                }}
              >
                Famous Initials
              </Typography>
            </Button>
          </Box>
          
          {/* Right side - Auth */}
          <Box>
            <AuthGen2 />
          </Box>
        </Toolbar>
      </AppBar>
    );
}

export default Header;